import React, { forwardRef } from 'react';
import { ButtonGroup as MuiButtonGroup } from '@mui/material';
import { isEmpty } from 'lodash';

import { reportErrorInProductionOrThrow } from '~/Utils';

/**
 This Component is a wrapper on MUI component.
 This component should be imported and not MUI directly!
**/

/**
 * Explicit ButtonGroup props based on actual usage in the codebase.
 */
export interface ButtonGroupProps {
  /** The variant to use */
  variant?: 'text' | 'outlined' | 'contained';
  /** The size of the buttons */
  size?: 'small' | 'medium' | 'large';
  /** CSS class name to apply to the root element */
  className?: string;
  /** The content of the button group */
  children?: React.ReactNode;
}

// MUI's ButtonGroup forwards its ref to the root <div>, so we type it accordingly.
const ButtonGroup = forwardRef<HTMLDivElement, ButtonGroupProps>(
  ({ variant, size, className, children, ...restProps }, ref) => {
    if (!isEmpty(restProps)) {
      reportErrorInProductionOrThrow(
        `Unexpected props passed to ButtonGroup: ${Object.keys(restProps).join(', ')}.
Examine if these need to be removed, or added explicitly to the ButtonGroupProps interface and to the component's signature.`,
        true
      );
    }
    return (
      <MuiButtonGroup variant={variant} size={size} className={className} ref={ref} {...restProps}>
        {children}
      </MuiButtonGroup>
    );
  }
);

ButtonGroup.displayName = 'ButtonGroup';

export default ButtonGroup;
